import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

import {createVuetify} from 'vuetify';
import colors from 'vuetify/lib/util/colors';

const opts = {
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: colors.deepPurple.darken4,
          secondary: colors.grey.darken3,
          block: colors.grey.lighten4,
          'block-2': colors.grey.lighten3,
          warning: colors.amber.lighten1,
          error: colors.red.darken4,
          success: colors.green.darken1,
        }
      },
      dark: {
        colors: {
          primary: colors.deepPurple.lighten1,
          secondary: colors.grey.darken2,
          block: colors.grey.darken3,
          'block-2': colors.grey.darken3,
          warning: colors.yellow.darken4,
          error: colors.red.darken4,
          success: colors.green.darken4,
        }
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
};

export default createVuetify(opts);
